import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";

import routes from "../../routes";
import Icon from "../Icon";

const Toggle = styled.nav`
  display: flex;
  padding: 0.25rem;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.25);

  ${({ floating }) =>
    floating &&
    `
    position: fixed;
    left: 50%;
    bottom: calc(1rem + env(safe-area-inset-bottom));
    transform: translateX(-50%);
    z-index: 11;
  `}
`;

const Option = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;
  background-color: ${props => (props.$active ? props.theme.info : "transparent")};
  color: ${props => (props.$active ? props.theme.white : props.theme.dark)};

  &:hover {
    color: ${props => (props.$active ? props.theme.white : props.theme.info)};
  }
`;

/**
 * Switches between the two ways of searching, the map page and the list page. `active` names
 * the page it is rendered on; `floating` positions it over a full-screen layout.
 */
const SearchViewToggle = ({ active, floating, className }) => (
  <Toggle floating={floating} className={className}>
    <Option to={routes.searchMap} $active={active === "map"}>
      <Icon name="Map" size="small" />
      <FormattedMessage id="pages.SearchMap.showMap" />
    </Option>
    <Option to={routes.search} $active={active === "list"}>
      <Icon name="List" size="small" />
      <FormattedMessage id="pages.SearchMap.showSearch" />
    </Option>
  </Toggle>
);

SearchViewToggle.propTypes = {
  active: PropTypes.oneOf(["map", "list"]).isRequired,
  floating: PropTypes.bool,
  className: PropTypes.string,
};

SearchViewToggle.defaultProps = {
  floating: false,
  className: null,
};

export default SearchViewToggle;
